import { Modal } from "tailwindcss-stimulus-components"
import TomSelect from "tom-select"

export default class extends Modal {

    open(e) {
        super.open(e);

        // set focus to the first input element in the modal.
        let input = this.element.querySelector('input');
        // if there is a tomselect element, output the first one to the console
        let tomselect = this.element.querySelector('.ts-control');
        
        if (tomselect) {
            // get the existing tomselect instance
            tomselect.focus();
        } else if (input) {
            input.focus();
        }
    }

    submitEnd(event) {
        // Handle form submission end
        if (event.detail.success) {
            // Close modal on successful submission
            this.close();
            
            // Check if this is a todo form and open the todos tab
            this.openTodosTab();
        } else {
            // Keep modal open on error
        }
    }

    openTodosTab() {
        // Look for the todos tab in the current page
        const tabsController = document.querySelector('[data-controller="tabs"]');
        if (tabsController) {
            // Find the todos tab by looking for text content that includes "Todos" or "Aufgaben"
            const todosTab = Array.from(tabsController.querySelectorAll('a[data-tabs-target="tab"]')).find(tab => 
                tab.textContent.includes('Todos') || 
                tab.textContent.includes('Aufgaben') ||
                tab.id === 'customer_todos_tab'
            );
            
            if (todosTab) {
                // Trigger the tab change
                todosTab.click();
            }
        }
    }

    close() {
        super.close();
        // Reset form when closing
        const form = this.element.querySelector('form');
        if (form) {
            form.reset();
        }
    }
}